import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-modal-recuperar',
  templateUrl: './modal-recuperar.page.html',
  styleUrls: ['./modal-recuperar.page.scss'],
})
export class ModalRecuperarPage implements OnInit {

  constructor(
    private modalCtrl: ModalController
  ) { }

  ngOnInit() {
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
